import DepoEventDetails from './DepoEventDetails';

export default DepoEventDetails;
